import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row.exclusions');

const ExcludeStrongNoScoresCheckbox = () => {
  const { watch, setValue } = useFormContext();
  const noStrongNoScores: boolean = watch('no_strong_no_scores');

  return (
    <Checkbox
      data-provides={'talent-matching-no-strong-no-checkbox'}
      checked={noStrongNoScores}
      onChange={(checked) =>
        setValue('no_strong_no_scores', checked, { shouldDirty: true })
      }
      label={t('strong_no_scores')}
      value={'no_strong_no_scores'}
    />
  );
};

export default ExcludeStrongNoScoresCheckbox;
